module.exports = __webpack_public_path__ + "static/media/Protector.a47ffa07.svg";